import { useMutation } from '@tanstack/react-query';
import { regenerateCoverImageFromFile } from '../services/regenerateCoverImage';

/** POST /admin/regenerate-cover-image */
export const useRegenerateCoverImageMutation = (options = {}) => {
  return useMutation({
    mutationKey: ['regenerate-cover-image'],
    mutationFn: ({ file, signal }) => regenerateCoverImageFromFile(file, { signal }),
    ...options,
  });
};
